<template>
	<div class="p4 xs-12">
		<core-form-input
			name="amountLogic"
			componentName="j-base-input-text"
			:label="$t('amount_logic')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.amountLogic"
		/>
		<core-form-input
			class="mt6"
			componentName="core-select-currency"
			name="currencyCode"
			:label="$t('currency')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.currencyCode"
		/>

		<slot :onSubmit="onSubmit"></slot>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"

export default {
	components: { CoreFormInput },

	props: {
		initialValue: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},

	data() {
		return {
			form: {}
		}
	},

	methods: {
		async onSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return
			this.$emit("submit", this.form)
		}
	},

	watch: {
		/**
		 * When initial payload changes, upsert this.form
		 */
		initialValue: {
			handler(newValue) {
				const { currencyCode, amountLogic } = newValue
				this.form = { ...this.form, currencyCode, amountLogic }
			},
			immediate: true
		}
	}
}
</script>

<style></style>
